import React from "react";

export default function SectionHeader({ eyebrow, title, description, align = "left", testid }) {
  return (
    <div data-testid={testid} className={`mb-12 ${align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-3xl"}`}>
      {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-forest leading-[1.1] mb-4">{title}</h2>
      {description && <p className="text-base text-slateneutral leading-relaxed">{description}</p>}
    </div>
  );
}
